<template>
  <div class="container">
    <content-header :data="[{text:'小程序首页商品', path: ''}]"></content-header>
    <div class="content">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="新品上市" name="new">
          <div class="content-list">
            <el-table
              :data="tableNew"
              border
              stripe>
              <el-table-column
                type="index"
                width="80">
              </el-table-column>
              <el-table-column
                prop="name"
                label="商品名称"
                width="150">
              </el-table-column>
              <el-table-column
                prop="manufacture"
                label="品牌"
                width="150">
              </el-table-column>
              <el-table-column
                prop="description"
                label="描述">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="removeNew(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="热卖商品" name="hot">
          <div class="content-list">
            <el-table
              :data="tableHot"
              border
              stripe>
              <el-table-column
                type="index"
                width="80">
              </el-table-column>
              <el-table-column
                prop="name"
                label="商品名称"
                width="150">
              </el-table-column>
              <el-table-column
                prop="manufacture"
                label="品牌"
                width="150">
              </el-table-column>
              <el-table-column
                prop="description"
                label="描述">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="removeHot(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="所有商品" name="all">
          <div class="content-bar">
            <div class="search-entry">
              <el-select v-model="brand_id" clearable value-key="id" placeholder="请选择品牌" @change="searchHandle">
                <el-option
                  v-for="item in brandIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="search-entry">
                <el-input
                  placeholder="请输入查询关键字"
                  @keyup.enter.native="searchHandle"
                  v-model="keywords">
                </el-input>
            </div>
            <div class="search-btn">
              <el-button type="primary" @click="searchHandle">查询</el-button>
            </div>
          </div>
          <!-- 列表区域 -->
          <div class="content-list">
            <el-table
              :data="tableData"
              border
              stripe>
              <el-table-column
                type="index"
                width="80">
              </el-table-column>
              <el-table-column
                prop="name"
                label="商品名称"
                width="150">
              </el-table-column>
              <el-table-column
                prop="manufacture"
                label="品牌"
                width="150">
              </el-table-column>
              <el-table-column
                prop="description"
                label="描述">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="addNew(scope)" type="text" size="small" >添加到新品</el-button>
                  <el-button @click="addHot(scope)" type="text" size="small" >添加到热卖</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination" v-if="total > curSize">
              <el-pagination
                @size-change="pageSizeChange"
                @current-change="curPageChange"
                :current-page="curPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="curSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import ProductModel from 'models/product'
  import BrandModel from 'models/brand'
  import { mapState } from 'vuex'

  export default {
    components: {
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        activeTab: 'new',
        keywords: '',
        tableData: [],
        formLabelWidth: '80px',
        curPage: 1,
        curSize: 10,
        total: 0,
        //
        brand_id: '',
        brandIds: [],
        //
        tableNew: [],
        tableHot: []
      }
    },
    created () {
      this.getObjList()
      BrandModel.find().then(res => {
        this.brandIds = res.rows
      })
      this.getNewList()
      this.getHotList()
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      handleTabClick (tab, event) {
        // console.log(tab, event)
      },
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize,
          notInCategory: '11501,11502'
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        ProductModel.findByCategroy(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      getNewList () {
        ProductModel.findByCategroy({curPage: 1, pageSize: 100, categoryId: 11501}).then(res => {
          this.tableNew = res.rows
          this.total = res.total
        })
      },
      getHotList () {
        ProductModel.findByCategroy({curPage: 1, pageSize: 100, categoryId: 11502}).then(res => {
          this.tableHot = res.rows
          this.total = res.total
        })
      },
      addNew (item) {
        this.$confirm('确认添加到新品上市?')
          .then(_ => {
            ProductModel.attachCategory({
              id: item.row.id,
              categoryId: 11501
            }).then(() => {
              this.getNewList()
              this.$message({ message: '添加成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '添加失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      addHot (item) {
        this.$confirm('确认添加到热卖商品?')
          .then(_ => {
            ProductModel.attachCategory({
              id: item.row.id,
              categoryId: 11502
            }).then(() => {
              this.getHotList()
              this.$message({ message: '添加成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '添加失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      removeNew (item) {
        this.$confirm('确认删除?')
          .then(_ => {
            ProductModel.detachCategory({
              id: item.row.id,
              categoryId: 11501
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '删除失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      removeHot (item) {
        this.$confirm('确认删除?')
          .then(_ => {
            ProductModel.detachCategory({
              id: item.row.id,
              categoryId: 11502
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '删除失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      searchHandle () {
        this.getObjList({keywords: this.keywords, brandId: this.brand_id})
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding-top: 5px
    padding-left: 10px
    padding-right: 10px
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
      .search-btn
        display: inline-block
        vertical-align: top
      .action-btn
        display: inline-block
        vertical-align: top
        float: right
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
</style>



// WEBPACK FOOTER //
// src/views/HomeProduct.vue